<template>
    <div>
        <div class="card shadow mb-4">
            <div class="card-header py-3">
                <h3 class="m-0 font-weight-bold text-primary mb-2">Test Types  
                    <router-link to="/admin/test-types/add" class="btn btn-primary float-right"><icon icon="plus-circle" /> Add New Test Type</router-link>
                </h3>
                </div>
            <div v-if="deleteResponse.success != null" v-bind:class="{ 'alert-success': deleteResponse.success, 'alert-danger': !deleteResponse.success }" class="alert" role="alert">
                {{deleteResponse.message}}
            </div>
            <div class="card-body">
                <div class="table-responsive">
                    <b-table 
                        show-empty
                        striped
                        :items="testTypes"
                        :fields="fields">
                        <template v-slot:cell(title)="row">
                            {{ row.item.title }}
                        </template>

                        <template v-slot:cell(modify)="row">
                            <router-link :to="'/admin/test-types/edit/' + row.item.id " class="btn btn-warning">Modify</router-link >
                        </template>

                        <template v-slot:cell(delete)="row">
                            <button @click="enableDeleteModal(row.item)" class="btn btn-danger">Delete</button >
                        </template>
                    </b-table>
                </div>
            </div>
        </div>
        <modal :title="modalTitle" :body="modalBody" :button="modalButtonText" @action="deleteTestType(modalTestTypeId)" v-if="showModal" @close="showModal = false"></modal>
    </div>
</template>

<script>
import Modal from './../../misc/Modal.vue';
export default {
    components: {
            modal: Modal
    },
    data() {
        return {
            testTypes: [],
            fields: [
                { key: 'title', label: 'Title', sortable: true },
                { key: 'modify', label: 'Modify', tdClass: 'fit' },
                { key: 'delete', label: 'Delete', tdClass: 'fit' }
            ],
            deleteResponse: {},
            modalBody: "Select 'Delete' below if you are sure you want to delete the Test Type ",
            modalTitle: "Delete Confirmation",
            modalButtonText: "Delete",
            showModal: false,
            modalTestTypeId: null
        }
    },
    methods: {
        enableDeleteModal: function(testType){
            this.modalBody = this.modalBody + testType.title + ' with title translation key ' + testType.titleTranslationKey;
            this.modalTestTypeId = testType.id;
            this.showModal = true;
        },
        deleteTestType: function(testTypeId) {
            let self = this;
            this.$http.delete('/api/test-types/delete/' + testTypeId)
            .then(response => {
                var tempDeleteResponse = response.data;
                tempDeleteResponse.id = testTypeId;
                self.deleteResponse = tempDeleteResponse;
            })
            .catch(error => {
                console.log(error);
            })
        },
        loadTestTypes: function() {
            let self = this;
            this.$http.get('/api/test-types/get-all')
            .then(response => {
                self.testTypes = response.data;
            })
            .catch(error => {
                console.log(error);
            })
        },
    },
    mounted: function() {
        this.loadTestTypes();
    },
    watch: {
        deleteResponse: function(val){
            if(val.success === true)
            {
                // get index of object with id: val.id
                var removeIndex = this.testTypes.map(function(item) { return item.id; }).indexOf(val.id);
                // remove object
                this.testTypes.splice(removeIndex, 1);
            }
            setTimeout(() => {this.deleteResponse.success = null}, 3000)
        }
    }
}
</script>

<style lang="scss" scoped>

</style>